export default "<ng-container\r\n  *ngTemplateOutlet=\"toolTipTemplate; context: { data: data, key: key }\"\r\n>\r\n</ng-container>\r\n";